@if (isEdit) {
  <h1 class="title">Update Beneficial Owner</h1>
} @else {
  <h1 class="title">Add Beneficial Owner</h1>
}

<button class="close-button" (click)="activeModal.close()"><rkt-icon name="times" /></button>

<div class="details-page-edit-form">
  @if (!isEdit) {
    <ng-container *ngTemplateOutlet="beneficiaryInformation"></ng-container>
  }

  @if (isEdit) {
    <app-expandable-form-section
      title="Beneficial Owner Information"
      titleIconName="beneficiary"
      [isExpanded]="sectionsExpanded.beneficiaryInfo"
      (toggled)="toggleSection('beneficiaryInfo')"
    >
      <ng-container *ngTemplateOutlet="beneficiaryInformation"></ng-container>
    </app-expandable-form-section>
  }

  <ng-template #beneficiaryInformation>
    <form [formGroup]="editForm">
      <rkt-form [form]="editForm" [fields]="editFormFields" [model]="editFormModel" />
    </form>

    <div class="separator"></div>

    <form [formGroup]="editOwningForm">
      <rkt-form [form]="editOwningForm" [fields]="editOwningFormFields" [model]="editFormModel" />
    </form>
  </ng-template>

  @if (!isEdit) {
    <div class="separator"></div>

    <app-address-add
      type="PHYSICAL"
      (changed)="setAddresses($event, 'physicalAddresses')"
      (isFormInvalid)="addressFormValidity['PHYSICAL'] = $event"
    />

    <div class="separator"></div>

    <app-address-add
      type="MAILING"
      (changed)="setAddresses($event, 'mailingAddresses')"
      (isFormInvalid)="addressFormValidity['MAILING'] = $event"
    />

    <div class="separator"></div>

    <app-address-add
      type="SHIPPING"
      (changed)="setAddresses($event, 'shippingAddresses')"
      (isFormInvalid)="addressFormValidity['SHIPPING'] = $event"
    />
  }

  @if (isEdit) {
    <div class="separator"></div>

    <app-expandable-form-section
      title="Physical Address"
      titleIconName="location"
      [isExpanded]="sectionsExpanded.physicalAddress"
      (toggled)="toggleSection('physicalAddress')"
    >
      <app-address-edit
        type="PHYSICAL"
        [addresses]="beneficiaryAddresses.physicalAddresses"
        (changed)="setAddresses($event, 'physicalAddresses')"
        (isFormInvalid)="addressFormValidity['PHYSICAL'] = $event"
      />
    </app-expandable-form-section>

    <div class="separator"></div>

    <app-expandable-form-section
      title="Mailing Address"
      titleIconName="mailing"
      [isExpanded]="sectionsExpanded.mailingAddress"
      (toggled)="toggleSection('mailingAddress')"
    >
      <app-address-edit
        type="MAILING"
        [addresses]="beneficiaryAddresses.mailingAddresses"
        (changed)="setAddresses($event, 'mailingAddresses')"
        (isFormInvalid)="addressFormValidity['MAILING'] = $event"
      />
    </app-expandable-form-section>

    <div class="separator"></div>

    <app-expandable-form-section
      title="Shipping Address"
      titleIconName="shipping"
      [isExpanded]="sectionsExpanded.shippingAddress"
      (toggled)="toggleSection('shippingAddress')"
    >
      <app-address-edit
        type="SHIPPING"
        [addresses]="beneficiaryAddresses.shippingAddresses"
        (changed)="setAddresses($event, 'shippingAddresses')"
        (isFormInvalid)="addressFormValidity['SHIPPING'] = $event"
      />
    </app-expandable-form-section>

    <div class="separator"></div>
  }

  @if (submitError) {
    <div class="details-page-edit-form-error">{{ submitError }}</div>
  }

  <div class="buttons">
    <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>
    <button
      rktButton
      type="button"
      (click)="onSave()"
      [disabled]="loading || editForm.invalid || editOwningForm.invalid || this.isSomeAddressFormInvalid"
    >
      @if (isEdit) {
        Update Beneficial Owner
      } @else {
        Add Beneficial Owner
      }
    </button>
  </div>
</div>
